import { Box, Center } from '@chakra-ui/react';
import { ReactNode } from 'react';

export type ContainerProps = {
  children: ReactNode;
};

const Container = ({ children }: ContainerProps) => {
  return (
    <Center>
      <Box width={'100%'} maxWidth={'480px'}>
        {children}
      </Box>
    </Center>
  );
};

export default Container;
